"use client";

import { Button } from "@/components/ui/Button";
import type { BlokShoeFinder } from "@/storyblok";
import { useSetAtom } from "jotai";
import styles from "./ShoeFinderIntro.module.css";
import { SHOE_FINDER_IMAGES } from "./images";
import { shoeFinderStepAtom } from "./state";
import { useSlotMachine } from "./useSlotMachine";

interface ShoeFinderIntroProps {
	blok: BlokShoeFinder;
}

export const ShoeFinderIntro = ({ blok }: ShoeFinderIntroProps) => {
	const setStep = useSetAtom(shoeFinderStepAtom);
	const gridRef = useSlotMachine(SHOE_FINDER_IMAGES, 7);

	return (
		<div className={styles.root}>
			<div ref={gridRef} className={styles.grid} />
			<div className={styles.overlay}>
				<div className={styles.modal}>
					<h2 className={styles.title}>{blok.introTitle}</h2>
					{blok.introDescription && (
						<p className={styles.description}>{blok.introDescription}</p>
					)}
					<Button color="black" size="full" onClick={() => setStep(0)}>
						{blok.introButtonLabel || "Start"}
					</Button>
				</div>
			</div>
		</div>
	);
};
